"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typography_1 = require("../../controls/typography");
/**
 * Epsilon Typography Control Constructor
 */
wp.customize.controlConstructor['epsilon-typography'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new typography_1.EpsilonTypography(control);
        /**
         * Save the typography
         */
        control.container.on('change', '.customize-control-content > .epsilon-typography-input', function (e) {
            control.setting.set(jQuery(e.target).val());
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/controls/typography.ts
// module id = 23
// module chunks = 0